import '@angular/compiler';
import { PageAdminUserDetailComponent } from './page.admin.user.detail/page.admin.user.detail.component';
import { PortalSeasonTreeComponent } from './portal.season.tree/portal.season.tree.component';
import { PortalSeasonLoadingSeasonComponent } from './portal.season.loading.season/portal.season.loading.season.component';
import { PortalSeasonLoadingDefaultComponent } from './portal.season.loading.default/portal.season.loading.default.component';
import { ComponentNavAdminComponent } from './component.nav.admin/component.nav.admin.component';
import { PageKorslovoDashboardComponent } from './page.korslovo.dashboard/page.korslovo.dashboard.component';
import { PageKorslovoLearnComponent } from './page.korslovo.learn/page.korslovo.learn.component';
import { PageKorslovoCategoryItemComponent } from './page.korslovo.category.item/page.korslovo.category.item.component';
import { PageKorslovoCrosswordComponent } from './page.korslovo.crossword/page.korslovo.crossword.component';
import { PageKorslovoGameComponent } from './page.korslovo.game/page.korslovo.game.component';
import { PortalSeasonModalComponent } from './portal.season.modal/portal.season.modal.component';
import { LayoutAdminComponent } from './layout.admin/layout.admin.component';
import { PageKorslovoCategoryComponent } from './page.korslovo.category/page.korslovo.category.component';
import { PageKorslovoMypageComponent } from './page.korslovo.mypage/page.korslovo.mypage.component';
import { PortalSeasonPaginationComponent } from './portal.season.pagination/portal.season.pagination.component';
import { PageAdminLessonsComponent } from './page.admin.lessons/page.admin.lessons.component';
import { ComponentNavBottomComponent } from './component.nav.bottom/component.nav.bottom.component';
import { PageAccessComponent } from './page.access/page.access.component';
import { PortalPostListComponent } from './portal.post.list/portal.post.list.component';
import { PageKorslovoQuizComponent } from './page.korslovo.quiz/page.korslovo.quiz.component';
import { PageAdminUsersComponent } from './page.admin.users/page.admin.users.component';
import { PageAdminQualityComponent } from './page.admin.quality/page.admin.quality.component';
import { PortalPostDetailComponent } from './portal.post.detail/portal.post.detail.component';
import { LayoutEmptyComponent } from './layout.empty/layout.empty.component';
import { PortalSeasonFormDropdownComponent } from './portal.season.form.dropdown/portal.season.form.dropdown.component';
import { PageAdminWordsComponent } from './page.admin.words/page.admin.words.component';
import { PageKorslovoReviewComponent } from './page.korslovo.review/page.korslovo.review.component';
import { LayoutKorslovoComponent } from './layout.korslovo/layout.korslovo.component';
import { PageAdminDashboardComponent } from './page.admin.dashboard/page.admin.dashboard.component';
import { PageAdminCategoriesComponent } from './page.admin.categories/page.admin.categories.component';

const INDEX_PAGE = "dashboard";

import { URLPattern } from "urlpattern-polyfill";
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

let app_routes: Routes = [
    {
        component: LayoutAdminComponent,
        "children": [
            {
                "path": "admin/users/:id",
                component: PageAdminUserDetailComponent,
                "app_id": "page.admin.user.detail"
            },
            {
                "path": "admin/lessons",
                component: PageAdminLessonsComponent,
                "app_id": "page.admin.lessons"
            },
            {
                "path": "admin/users",
                component: PageAdminUsersComponent,
                "app_id": "page.admin.users"
            },
            {
                "path": "admin/quality",
                component: PageAdminQualityComponent,
                "app_id": "page.admin.quality"
            },
            {
                "path": "admin/words",
                component: PageAdminWordsComponent,
                "app_id": "page.admin.words"
            },
            {
                "path": "admin/dashboard",
                component: PageAdminDashboardComponent,
                "app_id": "page.admin.dashboard"
            },
            {
                "path": "admin/categories",
                component: PageAdminCategoriesComponent,
                "app_id": "page.admin.categories"
            }
        ]
    },
    {
        component: LayoutKorslovoComponent,
        "children": [
            {
                "path": "dashboard",
                component: PageKorslovoDashboardComponent,
                "app_id": "page.korslovo.dashboard"
            },
            {
                "path": "learn/:id",
                component: PageKorslovoLearnComponent,
                "app_id": "page.korslovo.learn"
            },
            {
                "path": "category/:id",
                component: PageKorslovoCategoryItemComponent,
                "app_id": "page.korslovo.category.item"
            },
            {
                "path": "crossword/:lessonId",
                component: PageKorslovoCrosswordComponent,
                "app_id": "page.korslovo.crossword"
            },
            {
                "path": "game",
                component: PageKorslovoGameComponent,
                "app_id": "page.korslovo.game"
            },
            {
                "path": "category",
                component: PageKorslovoCategoryComponent,
                "app_id": "page.korslovo.category"
            },
            {
                "path": "mypage",
                component: PageKorslovoMypageComponent,
                "app_id": "page.korslovo.mypage"
            },
            {
                "path": "quiz/:id/:type",
                component: PageKorslovoQuizComponent,
                "app_id": "page.korslovo.quiz"
            },
            {
                "path": "review",
                component: PageKorslovoReviewComponent,
                "app_id": "page.korslovo.review"
            }
        ]
    },
    {
        component: LayoutEmptyComponent,
        "children": [
            {
                "path": "access",
                component: PageAccessComponent,
                "app_id": "page.access"
            }
        ]
    }
];

export class RouteInfo {
    public path: any = "";
    public segment: any = {};

    constructor() { }
}

window.WizRoute = new RouteInfo();

let patternMatcher = (pattern: any, url: any) => {
    let urlpath = url.map((x: any) => x.path).join("/");
    let testurl = 'http://test/';
    pattern = '/' + pattern;
    urlpath = testurl + urlpath;
    pattern = new URLPattern({ pathname: pattern });
    pattern = pattern.exec(urlpath)
    if (pattern && pattern.pathname) {
        let posParams = {};
        for (let key in pattern.pathname.groups) {
            if (pattern.pathname.groups[key]) {
                posParams[key] = pattern.pathname.groups[key];
            }
        }
        window.WizRoute.path = url.map((x: any) => x.path).join("/");
        window.WizRoute.segment = posParams;

        return { consumed: url, posParams: posParams };
    }
    return null
}

let routes: Routes = [{
    matcher: (url: any) => {
        for (let i = 0; i < app_routes.length; i++) {
            let layout = app_routes[i];
            let layout_childs = layout.children;
            for (let j = 0; j < layout_childs.length; j++) {
                let child = layout_childs[j];
                let matcher = patternMatcher(child.path, url);
                if (matcher)
                    return null;
            }
        }
        return { consumed: url, posParams: {} };
    },
    redirectTo: INDEX_PAGE
}];

for (let i = 0; i < app_routes.length; i++) {
    let layout = app_routes[i];
    let layout_component = layout.component;
    let layout_childs = layout.children;

    let router: any = {
        path: '',
        component: layout_component,
        children: []
    };

    for (let j = 0; j < layout_childs.length; j++) {
        let child = layout_childs[j];
        router.children.push({
            matcher: (url: any) => {
                let matcher = patternMatcher(child.path, url);
                if (matcher) return matcher;
                return null;
            },
            component: child.component
        });
    }
    routes.push(router);
}

@NgModule({ imports: [RouterModule.forRoot(routes)], exports: [RouterModule] })
export class AppRoutingModule { }